import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { Observable } from 'rxjs';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';

@Injectable({
    providedIn: 'root'
})
export class BuildingInformationHistoryService {

    constructor(private http: HttpClient, private configurationService: ConfigurationService) { }

    getBuildingInformationHistory(userId: string, tenancyReference: string): Observable<any> {
        const assetApiUrl = this.configurationService.getConfig()?.shell.api.assetApiUrl;
        return this.http.get(assetApiUrl + 'BuildingInformationHistory?tenancyReferenceNumber=' + tenancyReference);
    }
}
